import { Container } from "@octopus-energy/coral/atoms"
import { useCoralConfig } from "@octopus-energy/coral/providers"
import { StoryblokMissingField } from "@octopus-energy/coral/storyblok"
import { token } from "@octopus-energy/coral-design/tokens"
import { StoryblokComponent, storyblokEditable } from "@storyblok/react"
import { type SbBlokPageSection } from "../../types"
import { getStoryblokBackgroundImageSet } from "../../utils/getStoryblokBackgroundImageSet"

interface DynamicPageSectionProps {
    blok: SbBlokPageSection
}

export default function DynamicPageSection({ blok }: DynamicPageSectionProps) {
    const { colorMode } = useCoralConfig();

    if (!blok?.blocks?.length) {
        return (
            <StoryblokMissingField
                blok="PageSection"
                field="Blocks"
            />
        )
    }

    const lighterBackgroundInDarkMode = blok.light
        ? token("colors.background.base.500")
        : token("colors.background.base.900");
    const stayDarkInLightMode = blok.light ?
        // if blok.light is true, Coral ColorMode check
        colorMode === "light" ? token("colors.background.base.100") : token("colors.background.base.500") :
        // if blok.light is false, Coral ColorMode check
        colorMode === "light" ? token("colors.contents.base.200") : token("colors.background.base.900");
    const backgroundColor = blok.stayDarkInLightMode ? stayDarkInLightMode : lighterBackgroundInDarkMode

    return (
        <section
            style={{
                backgroundImage: getStoryblokBackgroundImageSet(blok.backgroundImage?.filename),
                backgroundRepeat: "no-repeat",
                backgroundColor,
                backgroundSize: blok.backgroundImageSize || "contain",
                backgroundPosition: `${blok.backgroundImagePositionX || "left"} ${blok.backgroundImagePositionY || "top"}`,
            }}
            {...storyblokEditable(blok)}
        >
            <Container
                maxWidthPreset="lg"
                marginY="none"
                marginX="auto"
                padding={{ base: "md", md: "xxl" }}
            >
                {blok.blocks.map((nestedBlok) => (
                    <StoryblokComponent
                        blok={nestedBlok}
                        key={nestedBlok._uid}
                    />
                ))}
            </Container>
        </section>
    )
}
